import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-material-pg-icon-button',
  templateUrl: './material-pg-icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule],

})

export class MaterialPgIconButtonComponent {

  @Input() disabled = false;
  @Input() icon = '';
  @Input() iconOnly = false;
  @Input() iconClass = '';
  // @Input() iconType: 'material' | 'fontawesome' = 'material';
  // _disabled!: boolean;

  @Output() clicked = new EventEmitter<boolean>();

  click() {
    this.clicked.emit(true);
  }

}
